var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_9868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "#0C6CF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8 13.8924C15.8 15.4344 14.5484 16.458 12.7004 16.6122V18H11.4344V16.5984C10.1844 16.4575 8.99678 15.9773 8 15.21L8.9312 13.9344C9.761 14.5794 10.5464 15 11.4926 15.1404V12.3924C9.368 11.8596 8.3786 11.0886 8.3786 9.5046C8.3786 7.9908 9.6152 6.9534 11.4344 6.813V6H12.7004V6.8412C13.6899 6.95111 14.6332 7.31852 15.4364 7.9068L14.621 9.2244C13.9808 8.7618 13.3262 8.4672 12.6422 8.3274V10.9908C14.8544 11.5236 15.8 12.3786 15.8 13.8924ZM11.492 10.6962V8.229C10.5758 8.2992 10.0958 8.79 10.0958 9.4068C10.0958 9.9948 10.3718 10.374 11.4926 10.6968L11.492 10.6962ZM14.0828 13.9902C14.0828 13.3602 13.7768 12.9816 12.6422 12.6588V15.1968C13.559 15.126 14.0828 14.6634 14.0828 13.9908V13.9902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_9868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.5837319f1b2c77d92181d7525fac3679.svg";
export { ForwardRef as ReactComponent };